import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcovaDatePipe } from './ecova-date.pipe';
import { EcovaCurrencyPipe } from './ecova-currency.pipe';
import { EcovaUsagePipe } from './ecova-usage.pipe';
import { EcovaRatePipe } from './ecova-rate.pipe';
import { EcovaBooleanToActiveDisabledPipe, EcovaBooleanToYesEmptyPipe, EcovaBooleanToYesNoPipe } from './ecova-boolean.pipes';
import { EcovaDisplayNamePipe } from './ecova-displayName.pipe';
import { EngieClientId2namePipe } from './engie-client-id2name.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    EcovaDatePipe,
    EcovaCurrencyPipe,
    EcovaUsagePipe,
    EcovaRatePipe,
    EcovaDisplayNamePipe,
    EcovaBooleanToActiveDisabledPipe, EcovaBooleanToYesEmptyPipe, EcovaBooleanToYesNoPipe, EngieClientId2namePipe
  ],
  exports: [
    EcovaDatePipe,
    EcovaCurrencyPipe,
    EcovaUsagePipe,
    EcovaRatePipe,
    EcovaDisplayNamePipe,
    EcovaBooleanToActiveDisabledPipe, EcovaBooleanToYesEmptyPipe, EcovaBooleanToYesNoPipe, EngieClientId2namePipe
  ]
})
export class SharedPipesModule {
  static forRoot(): ModuleWithProviders<SharedPipesModule> {
    return {
        ngModule: SharedPipesModule,
        providers: []
    };
}
}
